import {
    CHANGE_CLIENT_TO_NOTIFICATION_LIST,
    RESET_CLIENT_TO_NOTIFICATION_LIST,
    OPEN_CLIENT_TO_NOTIFICATION_LIST,
    OPEN_WRITE_MESSAGE_MODAL,
    SEND_MESSAGE_REQUESTED,
    SEND_MESSAGE_SUCCESS,
    SEND_MESSAGE_FAILED,
    GET_NOTIFICATIONS_LIST_REQUESTED,
    GET_NOTIFICATIONS_LIST_SUCCESS,
    GET_NOTIFICATIONS_LIST_FAILED,
    CLIENT_DELETED_FROM_THE_LIST,
  } from './actionTypes'
  
  export const changeClientList = payload => ({
    type: CHANGE_CLIENT_TO_NOTIFICATION_LIST,
    payload
  })
  
  export const resetClientList = payload => ({
    type: RESET_CLIENT_TO_NOTIFICATION_LIST,
    payload
  })

  export const openClientList = payload => ({
    type: OPEN_CLIENT_TO_NOTIFICATION_LIST,
    payload
  })

  export const openWriteMessageModal = payload => ({
    type: OPEN_WRITE_MESSAGE_MODAL,
    payload
  })

  export const requestForSendMessage = payload => ({
    type: SEND_MESSAGE_REQUESTED,
    payload
  })

  export const requestForSendMessageSuccess = payload => ({
    type: SEND_MESSAGE_SUCCESS,
    payload
  })

  export const requestForSendMessageFailed = payload => ({
    type: SEND_MESSAGE_FAILED,
    payload
  })

  export const getNotificationsListRequested = payload => ({
    type: GET_NOTIFICATIONS_LIST_REQUESTED,
    payload
  })

  export const getNotificationsListSuccess = payload => ({
    type: GET_NOTIFICATIONS_LIST_SUCCESS,
    payload
  })

  export const getNotificationsListFailed = payload => ({
    type: GET_NOTIFICATIONS_LIST_FAILED,
    payload
  })

  export const clientDeleted = payload => ({
    type: CLIENT_DELETED_FROM_THE_LIST,
    payload
  })
